/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCart200ResponseInner } from './GetCart200ResponseInner';
import {
    GetCart200ResponseInnerFromJSON,
    GetCart200ResponseInnerFromJSONTyped,
    GetCart200ResponseInnerToJSON,
    GetCart200ResponseInnerToJSONTyped,
} from './GetCart200ResponseInner';
import type { CreateOrderRequestAddress } from './CreateOrderRequestAddress';
import {
    CreateOrderRequestAddressFromJSON,
    CreateOrderRequestAddressFromJSONTyped,
    CreateOrderRequestAddressToJSON,
    CreateOrderRequestAddressToJSONTyped,
} from './CreateOrderRequestAddress';

/**
 * 
 * @export
 * @interface CreateOrderRequest
 */
export interface CreateOrderRequest {
    /**
     * 
     * @type {CreateOrderRequestAddress}
     * @memberof CreateOrderRequest
     */
    address?: CreateOrderRequestAddress;
    /**
     * 
     * @type {Array<GetCart200ResponseInner>}
     * @memberof CreateOrderRequest
     */
    lines: Array<GetCart200ResponseInner>;
}

/**
 * Check if a given object implements the CreateOrderRequest interface.
 */
export function instanceOfCreateOrderRequest(value: object): value is CreateOrderRequest {
    if (!('lines' in value) || value['lines'] === undefined) return false;
    return true;
}

export function CreateOrderRequestFromJSON(json: any): CreateOrderRequest {
    return CreateOrderRequestFromJSONTyped(json, false);
}

export function CreateOrderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'address': json['address'] == null ? undefined : CreateOrderRequestAddressFromJSON(json['address']),
        'lines': ((json['lines'] as Array<any>).map(GetCart200ResponseInnerFromJSON)),
    };
}

export function CreateOrderRequestToJSON(json: any): CreateOrderRequest {
    return CreateOrderRequestToJSONTyped(json, false);
}

export function CreateOrderRequestToJSONTyped(value?: CreateOrderRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address': CreateOrderRequestAddressToJSON(value['address']),
        'lines': ((value['lines'] as Array<any>).map(GetCart200ResponseInnerToJSON)),
    };
}

